import AccountPicker from "../../components/AccountPicker";
import type { Dispatch, SetStateAction } from "react";
import type { Account, Payee } from "../../types";
import FormActions from "../../components/FormActions";
import DateInput from "../../components/DateInput";
import PayeeField from "../../components/PayeeField";
import type { IouDraft } from "./iou-drafts";

/** Logs a new loan: who, which way, how much, and the account the money moved through. */
export default function IouForm({ draft, setDraft, payees, accounts, payeeName, busy, onSubmit, onCancel: _onCancel, onPayeeCreated }: {
  draft: IouDraft;
  setDraft: Dispatch<SetStateAction<IouDraft | null>>;
  payees: Payee[];
  accounts: Account[];
  payeeName: (id: string) => string;
  busy: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  onPayeeCreated: () => void;
}) {
  const label = draft.payeeId
    ? (draft.payeeId.startsWith("local:") ? draft.payeeName || payeeName(draft.payeeId) : payeeName(draft.payeeId))
    : "";
  return (
    <form className="account-editor" onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
      <label>Payee<PayeeField
        payees={payees}
        value={draft.payeeId}
        pendingName={!draft.payeeId || draft.payeeId.startsWith("local:") ? draft.payeeName : undefined}
        onChange={(payeeId, name) => setDraft({
          ...draft,
          payeeId,
          payeeName: payeeId && !payeeId.startsWith("local:") ? undefined : (name || ""),
        })}
        onCreated={onPayeeCreated}
      /></label>
      <label>Direction<select value={draft.direction} onChange={(e) => setDraft({ ...draft, direction: e.target.value as "Owed to us" | "We owe" })}><option value="Owed to us">{label || "They"} owe{label ? "s" : ""} us</option><option value="We owe">We owe {label || "them"}</option></select></label>
      <label>Amount<input required inputMode="decimal" value={draft.originalAmount} onChange={(e) => setDraft({ ...draft, originalAmount: e.target.value })} /></label>
      <label>Description<input required value={draft.description} onChange={(e) => setDraft({ ...draft, description: e.target.value })} placeholder="e.g. Personal loan, PS5 sale" /></label>
      <div className="account-editor-grid">
        <label>Date<DateInput required value={draft.createdDate} onChange={(e) => setDraft({ ...draft, createdDate: e.target.value })} /></label>
        <label><span className="field-label">Due date <small>Optional</small></span><DateInput value={draft.dueDate} onChange={(e) => setDraft({ ...draft, dueDate: e.target.value })} /></label>
      </div>
      <AccountPicker label="Account" accounts={accounts} value={draft.fundingAccountId} onChange={(id) => setDraft({ ...draft, fundingAccountId: id })} required />
      <p className="settings-note">{draft.direction === "Owed to us" ? "Money left this account just now (a loan you gave)" : "Money arrived in this account just now (a loan you received)"} — it'll be recorded as a transaction on it, in that account's currency.</p>
      <FormActions label="Save IOU" busy={busy} disabled={!draft.payeeId || !draft.fundingAccountId} />
    </form>
  );
}
